import { Typography } from '@mui/material'
import React from 'react'

const ProfileAttributeTable = ({ onAttributesChange, moduleAttributes }) => {
  return (
    <React.Fragment>
      <Typography variant="body2" align="center" sx={{ my: 4 }}>
        PROFILE module is not ready for the competition system yet.
      </Typography>
    </React.Fragment>
  )
}

export default ProfileAttributeTable
